/**
 * @fileoverview Data models
 */
import draft from 'draft-js'
import immutable from 'immutable'

import idgen from './idgen'

const NoteRecord = immutable.Record({
  id: '',
  content: null,
  createdAt: 0,
  updatedAt: 0,
})

class Note extends NoteRecord {
  id: string;
  content: draft.ContentState;
  createdAt: number;
  updatedAt: number;

  toDb(): Object {
    return {
      // TODO consider not storing as JSON and just as a nested object. Might
      // be better for ultimate querying.
      content: JSON.stringify(draft.convertToRaw(this.content)),
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    }
  }

  static generateId(): string {
    return idgen.generateId(16)
  }

  static fromDb(snapshot: firebase.Snapshot): Note {
    const val = snapshot.val()
    return new Note({
      id: snapshot.key,
      content: draft.convertFromRaw(JSON.parse(val.content)),
      createdAt: val.createdAt,
      updatedAt: val.updatedAt,
    })
  }
}

export default {Note}



/** WEBPACK FOOTER **
 ** ./src/model.js
 **/